import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Button from '../common/button/Button';
import Svg from '../common/svg/Svg';

import svgs from '../../constants/svgs';

export const ExpandButton = ({
    className,
    expanded,
    iconProps = {},
    ...otherProps
}) => {
    return (
        <Button
            className={cx(
                'expandbtn',
                expanded && 'expandbtn--expanded',
                className
            )}
            {...otherProps}
        >
            <Svg
                image={svgs.CARET}
                {...iconProps}
                className={cx(
                    'expandbtn__icon',
                    expanded && 'expandbtn__icon--expanded',
                    iconProps.className
                )}
            />
        </Button>
    );
};

ExpandButton.displayName = 'ExpandButton';

ExpandButton.propTypes = {
    className: PropTypes.string,
    expanded: PropTypes.bool,
    iconProps: PropTypes.object
};
